// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.deployment.terminal_session.TerminalSession

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";

export interface TerminalSessionData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "TerminalSession";
    id: string;
    shell: string;
    rows: number;
    cols: number;
    is_alive: boolean;
    claude_session_id: string | null;
    name: string | null;
    output_chunks: string[];
}

export class TerminalSessionStore {
    readonly _entity_class_name = "TerminalSession" as const;
    id: string;
    shell: string;
    rows: number;
    cols: number;
    is_alive: boolean;
    claude_session_id: string | null;
    name: string | null;
    output_chunks: string[];
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: TerminalSessionData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.id = wrapEntity(data.id, transport, [...chainPath, "id"]);
        this.shell = wrapEntity(data.shell, transport, [...chainPath, "shell"]);
        this.rows = wrapEntity(data.rows, transport, [...chainPath, "rows"]);
        this.cols = wrapEntity(data.cols, transport, [...chainPath, "cols"]);
        this.is_alive = wrapEntity(data.is_alive, transport, [...chainPath, "is_alive"]);
        this.claude_session_id = wrapEntity(data.claude_session_id, transport, [...chainPath, "claude_session_id"]) ?? null;
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]) ?? null;
        this.output_chunks = wrapEntity(data.output_chunks, transport, [...chainPath, "output_chunks"]);
        makeObservable(this, {
            id: observable,
            shell: observable,
            rows: observable,
            cols: observable,
            is_alive: observable,
            claude_session_id: observable,
            name: observable,
            output_chunks: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async send_keys(keys: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "send_keys", [keys], {});
    }

    async get_scrollback_text(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "get_scrollback_text", [], {});
    }

    async resize(cols: any, rows: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "resize", [cols, rows], {});
    }
}

registerEntity("TerminalSession", TerminalSessionStore);
